import { createSlice } from '@reduxjs/toolkit';

import { reducers } from './reducers';
import { SliceState } from './slice-state';

const initialState: SliceState = {};

const sliceObj = createSlice({
    name: 'qa',
    initialState,
    reducers,
});

// register this in your root state
export const QaSliceReducer = sliceObj.reducer;

export const {
    // list of exported actions here
    setSomething,
} = sliceObj.actions;
